export const API_URL = process.env.REACT_APP_API_URL as string;
export const JWT_SECRET = '123456' as string;
export const HOST_URL = process.env.REACT_APP_HOST as string;
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID as string;
export const SCOPE =
  'email profile https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar.readonly' as string;
export const APP_PATH = process.env.REACT_APP_APPL_PATH as string | '';

export const FCM_CONFIG = process.env.REACT_APP_FCM_CONFIG as string;
export const VAPID_KEY = process.env.REACT_APP_FCM_VAPID as string;
export const SUPER_ADMIN_ROLE = 'super_admin';
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID as string;
export const PAYPAL_REDIRECT_URL = process.env.REACT_APP_PAYPAL_REDIRECT_URL as string;
export const PAYPAL_AUTH_URL = process.env.REACT_APP_PAYPAL_AUTH_URL as string;

export const REAL_TIME_RESERVATION = 'REAL_TIME';
export const REQUEST_RESERVATION = 'REQUEST';
export const STORAGE_PREFIX = process.env.REACT_APP_STORAGE_PREFIX as string;
export const ENABLE_GOOGLE_CONVERSION = process.env.REACT_APP_GA as string;
export const ALLOWED_PHONE_COUNTRIES =
  (process.env.REACT_APP_ALLOWED_PHONE_COUNTRIES || '')
    .split(',')
    .map(c => c.trim());
